import { useNotifications } from '@joor/design-system'

const SUCCESS_DESCRIPTION = 'The action has been completed successfully'
const WARNING_DESCRIPTION = 'Something needs your attention.'
const INFO_DESCRIPTION = 'For your information.'
const ERROR_DESCRIPTION = 'There has been an error'

type ToastsHookResult = {
  showSuccessToast: (description?: string) => void
  showErrorToast: (description?: string) => void
  showInfoToast: (description?: string) => void
  showWarningToast: (description?: string) => void
}

/**
 * This hook allow us to show error and success toasts.
 */
export const useToasts = (): ToastsHookResult => {
  const { addToasts } = useNotifications()

  const showSuccessToast = (description: string = SUCCESS_DESCRIPTION): void =>
    addToasts([{ title: 'Success', description, type: 'success' }])

  const showErrorToast = (description: string = ERROR_DESCRIPTION): void =>
    addToasts([{ title: 'Error', description, type: 'error' }])

  const showInfoToast = (description: string = INFO_DESCRIPTION): void =>
    addToasts([{ title: 'Info', description, type: 'info' }])

  const showWarningToast = (description: string = WARNING_DESCRIPTION): void =>
    addToasts([{ title: 'Warning', description, type: 'warning' }])

  return { showSuccessToast, showErrorToast, showInfoToast, showWarningToast }
}
